<ng-container *ngIf="loading$ | async">
    <div class="overlay"></div>
    <mat-progress-spinner [mode]="'determinate'" value="100"></mat-progress-spinner>
  </ng-container>

